<template>
<article>
    <div id="PageTitle">
	<div class="container">
		<h1 class="page-header">{{title}}</h1>
		<div id="Breadcrumbs">
        <a href="/">home</a> &gt; 
    
        <a href="/athome/" class="breadcrumb-1">@hOMe</a>

        <template v-if='$route != "resourcesearch"'>&gt; <span class="breadcrumb-1">{{title}}</span></template>
    </div>
      </div>
    </div>
    <div id="Pills">
      <div class="container">
        <ul class="nav nav-pills row">
          <router-link tag='li' exact-active-class="active" :to="{ name: 'resourcesearch', query: {  } }"><a>@hOMe</a></router-link>
          <router-link tag='li' exact-active-class="active" :to="{name: 'resourcesearch',  query: { tag: 'View' }}"><a>View</a></router-link>
          <router-link tag='li' exact-active-class="active" :to="{name: 'resourcesearch',  query: { tag: 'Read' }}"><a>Read</a></router-link>
          <router-link tag='li' exact-active-class="active" :to="{name: 'resourcesearch',  query: { tag: 'Do' }}"><a>Do</a></router-link>
          <router-link tag='li' exact-active-class="active" :to="{name: 'resourcesearch',  query: { tag: 'Listen' }}"><a>Listen</a></router-link>
          <router-link tag='li' exact-active-class="active" :to="{name: 'topics'}"><a>Browse Topics</a></router-link>
        </ul>
      </div>
    </div> 
	<section id="Content">
		<div class="container">
      <div>
          <router-view @updateHead='updateHead'></router-view>
			</div>
		</div>
	</section>
</article>
</template>

<script>
export default {
  name: 'resource',
  props: ['slug'],
  data() {
    return {
      title: '@hOMe'
    }
  },
  methods: {
    updateHead(resource) {
      this.title = resource.title;
      document.title = resource.title + " | Otago Museum";
    }
  },
  watch: {
    '$route'() {
      if (this.$route.name == 'resourcesearch') {
        this.title = "@hOMe";
        document.title = "@hOMe | Otago Museum";
      }
    }
  }
}
</script>